import { FC } from "react";

import { Stack } from "@mui/material";
import { FormType } from "@simplyk/common";

import { AuctionDate } from "../../../../blocks/campaign-details/CampaignDate/AuctionDate";
import { AuctionLocation } from "../../../../blocks/campaign-details/CampaignLocation/AuctionLocation";
import { CampaignTitle } from "../../../../blocks/campaign-details/CampaignTitle/CampaignTitle";
import { SalesOpeningChip } from "../../../../blocks/campaign-details/SalesOpeningChip/SalesOpeningChip";
import { useSalesOpenSchedule } from "../../../../blocks/campaign-details/SalesOpeningChip/useSalesOpenSchedule";
import { TicketingClosedChip } from "../../../../blocks/campaign-details/TicketingClosedChip/TicketingClosedChip";
import { useFormV2Context } from "../../../../contexts/FormV2Context";

import { TicketingV2CoreInfoLayout } from "./TicketingV2CoreInfoLayout";

export type AuctionV2CoreInfoProps = Record<string, never>;

export const AuctionV2CoreInfo: FC<AuctionV2CoreInfoProps> = () => {
  const { formObject, isEmbed, hasLocation, hasDate } = useFormV2Context(FormType.Ticketing);
  const { isTicketingClosed: ticketingIsClosed } = useFormV2Context(FormType.Ticketing);

  const { isSalesScheduled } = useSalesOpenSchedule();

  return (
    <TicketingV2CoreInfoLayout
      isEmbed={isEmbed}
      slots={{
        status: (formObject.isArchived || ticketingIsClosed) && <TicketingClosedChip />,
        formTitle: isSalesScheduled ? (
          <Stack gap={2}>
            <SalesOpeningChip isAuction />
            <CampaignTitle />
          </Stack>
        ) : (
          <CampaignTitle />
        ),
        date: hasDate ? <AuctionDate /> : undefined,
        location: hasLocation ? <AuctionLocation /> : undefined,
      }}
    />
  );
};
